<template>
  <el-collapse class="bg-white my-4 rounded-[5px] behavioral">
    <el-collapse-item
    >
      <template #title>
        <h2>Behavioral Assessment</h2>
      </template>
        <table class="w-full table-auto border-collapse border border-gray-300">
          <thead class="bg-gray-100">
          <tr>
            <th class="text-left px-4 py-2 border border-gray-300">
              Question
            </th>
            <th
                v-for="rating in ratings"
                :key="rating"
                class="text-center px-4 py-2 border border-gray-300"
            >
              {{ rating.label }}
            </th>
          </tr>
          </thead>
          <tbody v-if="filled">
          <tr
              v-for="(question, index) in savedAnswer"
              :key="index"
              class="border border-gray-300"
          >
            <td class="px-4 py-2 border border-gray-300 text-sm">
              <p class="whitespace-pre-wrap">{{ question.Question }}</p>
            </td>
            <td
                v-for="rating in ratings"
                :key="rating"
                class="text-center px-4 py-2 border border-gray-300"
            >
              <input
                  type="radio"
                  :name="'question-' + index"
                  :value="rating.value"
                  v-model="question.Answer"
                  class="form-radio text-primary"
              />
            </td>
          </tr>
          </tbody>
          <tbody v-else>
          <tr
              v-for="(question, index) in questions"
              :key="index"
              class="border border-gray-300"
          >
            <td class="px-4 py-2 border border-gray-300 text-sm">
              <p class="whitespace-pre-wrap">{{ question.Question }}</p>
            </td>
            <td
                v-for="rating in ratings"
                :key="rating"
                class="text-center px-4 py-2 border border-gray-300"
            >
              <input
                  type="radio"
                  :name="'question-' + index"
                  :value="rating.value"
                  v-model="answers[index]"
                  class="form-radio text-primary"
              />
            </td>
          </tr>
          </tbody>
        </table>
      <section class="flex gap-2 justify-end my-2">
        <el-button type="warning" @click="submitAnswers" v-if="!filled">Submit</el-button>
      </section>
    </el-collapse-item>

  </el-collapse>
</template>
<script>
import {mapGetters} from "vuex";
import axios from "axios";

export default {
  name: "behavioralAssessment.vue",
  data() {
    return {
      questions:[],
      filled:false,
      savedAnswer:[],
      ReviewPeriodIds: [],
      answers: {},
      ratings: [
        { value: 5, label: "Strongly Agree" },
        { value: 4, label: "Agree" },
        { value: 3, label: "Neutral" },
        { value: 2, label: "Disagree" },
        { value: 1, label: "Strongly Disagree" },
      ],
      info:{
        answer:''
      }
    }
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken", "getUserType", 'getUser',]),
  },
  created() {

    this.getPerformancePeriods()
  },
  methods: {
    getPerformancePeriods() {
      this.loading = true;
      let url = `${this.getOrganization}/performance/period/${this.$ApiVersion}/request`;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(url, options).then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.ReviewPeriodIds = response.data.Data;
              this.getStrategicQuestions()
            } else {
              this.$notify.error({
                title: "Failure",
                message: response.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;
            this.$notify.error({ title: "Failure", message: error.message });
          }
      );
    },
    submitAnswers() {
      const payload = {
        PeriodId: this.ReviewPeriodIds[0].Id,
        Assessments: this.questions.map((question, index) => ({
          QuestionId: question.Id,
          Answer: this.answers[index],
        })),
      };
      const unanswered = payload.Assessments.some((item) => !item.Answer);
      if (unanswered) {
        this.$message.error("Please answer all questions before submitting.");
        return;
      }
      let url = `${this.getOrganization}/performance/behavioral/assessment/${this.$ApiVersion}/create`;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
          .post(url, payload, options)
          .then((response) => {
            if (response.data.StatusCode == 200){
              this.$message.success("Feedback submitted successfully!");
              this.getBehavioralAssessment()
              this.resetForm();
            } else {
              this.$message.error(response.data.StatusMessage);
            }
          })
          .catch((error) => {
            this.$message.error(
                "Failed to submit feedback. Please try again later."
            );
            console.error(error);
          });
    },
    resetForm() {
      this.answers = [];
    },
    getStrategicQuestions() {
      this.loading = true;
      let url = `${this.getOrganization}/performance/strategic/question/${this.$ApiVersion}/request`;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(url, options).then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.questions = response.data.Data;
              this.getBehavioralAssessment()
            } else {
              this.$notify.error({
                title: "Failure",
                message: response.data.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;
            this.$notify.error({ title: "Failure", message: error.message });
          }
      );
    },
    getBehavioralAssessment(){
      this.loading = true;
      let url = `${this.getOrganization}/performance/behavioral/assessment/${this.$ApiVersion}/request`;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
        params: {
          employeeId:this.getUser.Id,
          periodId:this.ReviewPeriodIds[0].Id
        }
      };
      axios.get(url, options).then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              if (response.data.Data.length > 0){
                this.savedAnswer = response.data.Data
                this.filled = true
              }
            } else {
              this.$notify.error({
                title: "Failure",
                message: response.data.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;
            this.$notify.error({ title: "Failure", message: error.message });
          }
      );
    },
  }
}
</script>

<style scoped>

</style>